import { call, put } from 'redux-saga/effects';
import { getHistoryError, getHistorySuccess } from '../redux/actions';
import { getDeclarationsHistory } from '../services/api';

export function* getDeclarationsHistorySaga({ payload }) {
  const { isOk, data, error } = yield call(getDeclarationsHistory, payload);
  if (isOk) {
    yield put(getHistorySuccess(data));
  } else {
    yield put(getHistoryError(error));
  }
}
